import React, { useEffect, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight, FaExclamation, FaExclamationCircle, FaSpinner } from "react-icons/fa";
import ItemRowClienteSeguimiento from "./ItemRowClienteSeguimiento";
import Draggable from "../ui/Dragable";

const TablaServicioSeguimientoMarcas = ({ userRedux, clients }) => {
  // const [activeClients, setActiveClients] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [searchText, setSearchText] = useState("");
  // const [filteredClients, setFilteredClients] = useState([]);
  // const pagesSize = 20; 

  // useEffect(() => {
  //   const filtered = clientes.filter(client =>
  //     client.razonSocial?.toLowerCase().includes(searchText.toLowerCase())
  //   );
  //   setFilteredClients(filtered);
  //   setCurrentPage(1); 
  // }, [searchText, clientes]);

  // useEffect(() => {
  //   const totalPages = Math.ceil(filteredClients.length / pagesSize);
  //   const startIndex = (currentPage - 1) * pagesSize;
  //   const endIndex = startIndex + pagesSize;
  //   const currentClients = filteredClients.slice(startIndex, endIndex);

  //   setActiveClients(currentClients);
  // }, [currentPage, filteredClients]);

  // const totalPages = Math.ceil(filteredClients.length / pagesSize);

  return (
    <div className="flex-grow">
      <div>
        <Draggable showMiniMap={false}>
          <div className="overflow-y-auto overflow-x-auto w-full max-w-100vh mx-auto bg-gray-100 h-[69vh] border-b">
            <table className="w-full relative text-sm text-left text-gray-500">
              <thead className="text-xs sticky top-0 z-20 text-gray-900 uppercase bg-gray-200">
                <tr>
                  <th scope="col" className="px-6 py-3">Estado</th>
                  <th scope="col" className="px-6 py-3 text-center">Empresa</th>
                  <th scope="col" className="px-6 py-3 text-center">RUC</th>
                  <th scope="col" className="px-6 py-3 text-center">Total Servicios Contratados</th>
                  <th scope="col" className="px-6 py-3 text-center">Servicios Activos</th>
                  <th scope="col" className="px-6 py-3 text-center">Servicios Inactivos</th>
                  <th scope="col" className="px-6 py-3 text-center">Rubro</th>
                  <th scope="col" className="px-6 py-3 text-center">Nicho</th>
                </tr>
              </thead>
              <tbody>
                {clients?.length && clients?.length > 0 ? (
                  clients.map((client) => (
                    <ItemRowClienteSeguimiento
                      key={client.id}
                      userRedux={userRedux}
                      client={client}
                    />
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      <div className="flex text-zinc-500 h-[60vh] bg-white justify-center gap-2 items-center">
                          No hay registros que coincidan con la búsqueda<FaExclamationCircle />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        </Draggable>
      </div>
    </div>
  );
};

export default TablaServicioSeguimientoMarcas;
